import getLibraryMaps from './get-custom-components-library-maps';
import getImport from '../../get-import';

const getCustomComponentLibraryLoader = (config, library) => {
  const libraryMaps = getLibraryMaps(config);
  return getImport(library, libraryMaps);
};

export default getCustomComponentLibraryLoader;
